import React from 'react';
import { FullLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';

/**
 * `Layouts.Full` without the Container: the layout for a page that is full-bleed.
 *
 * Three DiscountMags pages are — the two subscription landing pages and bulk orders.
 * Their bands run edge to edge and each panel inside them containers its own contents,
 * so a Container around the lot would box the bands as well and there would be nothing
 * full-bleed left. They say `layoutName = 'Layouts.FullWide'` and keep the Containers
 * they already had, per panel.
 *
 * A layout rather than a prop on the page, because a page does not choose its own
 * chrome — it names one, and the mount resolves it (see tree.tsx). This is the whole
 * of it: everything else is Full's.
 *
 * TopMags has no counterpart, deliberately: nothing it serves is full-bleed, and a
 * layout with no page behind it is a name to keep in step for nothing.
 */
export default function FullWide(props: FullLayoutProps) {
  return <Full {...props} container={false} />;
}
